import { render, staticRenderFns } from "./viewGoPagesCampaign.vue?vue&type=template&id=183d179f&scoped=true"
import script from "./viewGoPagesCampaign.vue?vue&type=script&lang=js"
export * from "./viewGoPagesCampaign.vue?vue&type=script&lang=js"
import style0 from "./viewGoPagesCampaign.vue?vue&type=style&index=0&id=183d179f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d179f",
  null
  
)

export default component.exports